import React, { useRef } from 'react';
import {
  DateField,
  ReferenceField,
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
  Title,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import TextoField from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { imprimirNotaDevolucaoVenda } from '../../services';
import { PRIMARY_COLOR } from '../../utils';
import { PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR } from '../../utils/dadosTelas';
import ValorField from '../CreditoDevolucaoVenda/fields/ValorField';
//import ActionsField from './ActionsField';
import Dialogo from './ContainerDialogoVenda';
import DialogoDelete from './DialogoDelete';
import DialogoShow from './DialogoShow';
import Filter from './Filter';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoCreate = useRef(null);
  const refDialogoDelete = useRef(null);
  const refDialogoShow = useRef(null);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  function handleDelete(record) {
    if (refDialogoDelete.current) refDialogoDelete.current.handleOpen(record);
  }

  function handleCriar() {
    if (refDialogoCreate.current) {
      refDialogoCreate.current.handleOpen();
    }
  }

  function handleShow({ id }) {
    if (refDialogoShow.current) refDialogoShow.current.handleOpen(id);
  }

  async function imprimir(id) {
    if (id > 0) {
      const codigo = await imprimirNotaDevolucaoVenda(id);
      if (codigo < 0) {
        enqueueSnackbar('Erro ao imprimir a nota!', {
          variant: 'error',
        });
      }
    }
  }

  return (
    <>
      <Title title="Devoluções de Vendas" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField
            source="id"
            label="ID"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <DateField
            source="data"
            label="Data da Devolução"
            showTime
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ValorField
            source="valor"
            label="Valor"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ReferenceField
            label="Cliente"
            source="cliente_id"
            reference="clientes"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <ReferenceField
            source="responsavel_id"
            reference="users"
            label="Responsável"
            allowEmpty={false}
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            linkType={false}
          >
            <TextField source="username" />
          </ReferenceField>
          <TextoField
            source="venda.numero"
            label="Venda Referente"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="lalala"
            /* handleDelete={handleDelete}
            handleShow={handleShow} */
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            actions={[
              {
                key: 'show',
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: (rec) => handleShow(rec),
              },
              {
                key: 'print',
                title: 'Imprimir',
                icon: <PrintIcon />,
                onClick: (rec) => imprimir(rec.id),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCreate} />
      <DialogoDelete ref={refDialogoDelete} />
      <DialogoShow ref={refDialogoShow} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Devoluções de Vendas"
      filterDefaultValues={{
        periodo: {
          start: new Date(),
          end: new Date(),
        },
      }}
    />
  </ProtegerPagina>
);

export default List2;
